import { ContactTypeResolver } from './../contact/services/contact.resolver.service';
import {
    ClientListResolver,
    ClientEditResolver,
    ClientContactListResolver,
    ModuleListResolver,
    ClientListByBusinessResolver,
    CountryCodeResolver
} from './services/client.resolver.service';
import { ClientComponent } from './client.component';
import { CreateClientComponent } from './components/new-client/new-client.component';
import { ClientServices } from './services/client.services';
import { ClientListComponent } from './components/client-list/client-list.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { KubaExportModule } from './../shared/kuba-exports/kuba-export.module';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppSharedModule } from './../shared/appShared.module';
import { RouterModule } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { ConfirmationService, SharedModule } from 'primeng/api';
import { ContextMenuModule } from 'primeng/contextmenu';
import { EditorModule } from 'primeng/editor';
import { DatePickerModule } from 'primeng/datepicker';
import { TextareaModule } from 'primeng/textarea';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { DialogModule } from 'primeng/dialog';
import { MenuModule } from 'primeng/menu';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { PasswordValidatorModule } from 'src/app/shared/password-validator/password-validator.module';

@NgModule({ declarations: [ClientComponent, ClientListComponent, CreateClientComponent],
    bootstrap: [],
    imports: [
        BrowserModule,
        TableModule,
        SharedModule,
        FormsModule,
        DatePickerModule,
        EditorModule,
        ContextMenuModule,
        MenuModule,
        DialogModule,
        ReactiveFormsModule,
        SelectModule,
        TextareaModule,
        InputTextModule,
        TranslatePipe, TranslateDirective,
        AppSharedModule,
        RouterModule,
        ButtonModule,
        CheckboxModule,
        KubaExportModule,
        FileUploadModule,
        ConfirmDialogModule,
        TooltipModule,
        PasswordValidatorModule],
    providers: [
        ClientServices,
        ClientListResolver,
        ClientEditResolver,
        ClientContactListResolver,
        ConfirmationService,
        ModuleListResolver,
        ClientListByBusinessResolver,
        ContactTypeResolver,
        CountryCodeResolver,
        provideHttpClient(withInterceptorsFromDi()),]
})
export class ClientModule { }
